import InputWithDetails, {
  type InputWithDetailsPropsType,
} from "./InputWithDetails"

export type CheckboxWithDetailsPropsType = InputWithDetailsPropsType

const CheckboxWithDetails = (props: CheckboxWithDetailsPropsType) => (
  <InputWithDetails {...props} type="checkbox" />
)

export default CheckboxWithDetails
